<div class="row banner task-amend">
  <div class="col">
    <h6 class="pt-5px">
      <strong>Create Document Type</strong>
    </h6>
  </div>
  <div class="col">
    <button (click)="createDocumentType()" class="btn btn-secondary float-end">
      Create New Document Type
    </button>
  </div>
</div>

<form [formGroup]="filterForm" class="search">
  <div class="d-flex justify-content-start">
    <div class="m-0 me-3 w-35">
      <ng-select
        [items]="allDocumentTypes"
        [closeOnSelect]="true"
        [multiple]="false"
        bindLabel="documentTypeName"
        bindValue="id"
        formControlName="documentTypeId"
        [placeholder]="'Document Type'">
      </ng-select>
    </div>
    <div class="m-0 me-3 w-35 d-flex flex-row">
      <button
        (click)="clearFilter()"
        style="height: 29px"
        eosDebounce
        class="btn btn-primary ms-2">
        Clear
      </button>
      <button
        (click)="applyFilter()"
        style="height: 29px"
        eosDebounce
        class="btn btn-primary ms-2">
        Search
      </button>
    </div>
  </div>
</form>

<div class="d-flex table-resp candid-table mt-3" *ngIf="documentTypes.length">
  <table class="table table-bordered table-hover table-sm" style="font-size: 14px;">
    <thead>
      <tr>
        <th scope="col" style="width: 60px;">Sl No</th>
        <th scope="col">Document Type</th>
        <th scope="col">Active/Inactive</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let doc of documentTypes; index as i">
        <td>{{ i + 1 }}</td>
        <td>{{ doc.documentTypeName }}</td>
        <td>{{ doc.isActive ? 'Active' : 'Inactive' }}</td>
        <td class="text-center">
          <img
            class="cursor-pointer"
            title="Edit document type"
            (click)="editDocumentType(doc)"
            src="design/images/edit.png" />
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="card mt-3 text-center d-flex p-5" *ngIf="!documentTypes.length">
  <div class="card-body">No document types found</div>
</div>